import { useContext } from '@nuxtjs/composition-api';
import { Logger } from '~/helpers/logger';
 

export const useMenu = () => {
  const context = useContext();

  const loadTopMenu = async () => {
    Logger.debug('useMenu/loadTopMenu');

    const data = await context.app.$vsf.$magento.api.getTopMenu();
    Logger.debug('[Result] loadTopMenu:', { data });

    return data?.data;
  };
  

  return {
    loadTopMenu,
  };
};

export default useMenu;
